export const TRACKING_MESSAGE_ACTIONS = {
	edit: "Edit",
	delete: "Delete Message",
} as const;

export type TrackingMessageAction =
	(typeof TRACKING_MESSAGE_ACTIONS)[keyof typeof TRACKING_MESSAGE_ACTIONS];
